export default __webpack_public_path__ + "f819f3a9cb349a679be7433907f6c5c1.svg";